<template>
    <v-app id="us-v-app">
        <v-app-bar color="blue-grey" dense dark app>
            <v-btn icon @click="goBack">
                <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title style="font-size:1rem;width:95%;padding-left:0.4rem;">
              <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">团员列表
                <span v-if="companyInfo.COMPANY_NAME"> - {{companyInfo.COMPANY_NAME}}</span>
              </span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu left bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="inviteCommon">
                  <v-list-item-title>邀请新成员</v-list-item-title>
                </v-list-item>
                <v-list-item @click="inviteAdmin">
                  <v-list-item-title>邀请新管理员</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
        </v-app-bar>
        <v-content>
            <v-container style="padding-top:0.5rem;">
                <v-list subheader>
                  <v-subheader>管理员</v-subheader>
                  <v-list-item v-for="item in adminList" :key="item.GZ_COMPANY_STAFF_ID">
                      <v-list-item-avatar style="border-radius:0.3rem;">
                        <v-img v-if="item.STAFF_HEAD_URL!==''" :src="item.STAFF_HEAD_URL"></v-img>
                        <v-icon  v-else style="font-size:2rem;color:#9E9E9E;">mdi-account-circle</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          <div v-if="item.STAFF_NAME!==''">{{item.STAFF_NAME}}</div>
                          <div v-else>{{item.STAFF_ALIAS}}</div>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-icon>
                      </v-list-item-icon>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-list subheader v-if="showCommon">
                  <v-subheader>其它</v-subheader>
                  <v-list-item v-for="item in otherList" :key="item.GZ_COMPANY_STAFF_ID">
                      <v-list-item-avatar style="border-radius:0.3rem;">
                        <v-img v-if="item.STAFF_HEAD_URL!==''" :src="item.STAFF_HEAD_URL"></v-img>
                        <v-icon  v-else style="font-size:2.75rem;color:#9E9E9E;">mdi-account-circle</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          <div v-if="item.STAFF_NAME!==''">{{item.STAFF_NAME}}</div>
                          <div v-else>{{item.STAFF_ALIAS}}</div>
                          <div style="font-size:0.7rem;padding-top:0.2rem;color:#9e9e9e;">加入时间：{{$moment(item.JOIN_DATE).format('YYYY-MM-DD HH:mm')}}</div>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-icon>
                      </v-list-item-icon>
                  </v-list-item>
                </v-list>
            </v-container>
            <ShareQrCode ref="shareQrCode" title="邀请码" :visible.sync="shareVis" />
        </v-content>
    </v-app>
</template>

<script>
import ShareQrCode from '../../components/ShareQrCode'
export default {
  components: {
    ShareQrCode
  },
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      list: [],
      adminList: [],
      otherList: [],
      shareVis: false,
      // 分享有效期(分钟)
      shareExpiry: 10,
      showCommon: false,
      companyCode: '',
      companyInfo: {}
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    var staffInfo = that.$AppHelper.getCustomData('staff_info');
    that.companyCode = staffInfo.COMPANY_CODE;
    if (staffInfo && staffInfo.STAFF_ROLE === 'admin') {
      that.showCommon = true
    }
    var code = that.$route.query.code
    if (code) {
      that.companyCode = code
      that.showCommon = true
    }
    that.getCompanyInfo()
    that.getStaffList()
  },
  created() {
  },
  methods: {
    goBack() {
      var that = this;
      that.$router.goBack()
    },
    // 获取员工列表
    getStaffList() {
      var that = this;
      if (!that.companyCode) {
        return
      }
      that.$api.bz.getStaffList({ code: that.companyCode }).then(res => {
        console.log('getStaffList.res', res);
        if (!res.success) {
          // that.$toast.warning('获取员工列表失败');
          console.log('获取成员列表失败', res);
          return
        }
        that.list = res.data
        for (let index = 0; index < that.list.length; index++) {
          var item = that.list[index];
          if (item.STAFF_ROLE === 'admin') {
            that.adminList.push(item)
            continue;
          }
          that.otherList.push(item)
        }
      })
    },
    // 邀请新管理员
    inviteAdmin() {
      this.inviteStaff('admin')
      // var that = this
      // that.$refs.shareQrCode.setQrContent('123')
      // that.shareVis = !that.shareVis
    },
    // 邀请新员工
    inviteCommon() {
      this.inviteStaff('common')
    },
    inviteStaff(role) {
      var that = this;
      if (!that.companyCode) {
        return
      }
      that.$api.bz.createCompanyInvite({ company_code: that.companyCode, invite_expiry: that.shareExpiry, s_role: role }).then(res => {
        // console.log('生成公司邀请码', res)
        if (!res.success) {
          that.$toast.warning('生成邀请码失败')
          console.log('生成团队邀请码失败', res)
          return
        }
        var data = res.data
        that.$refs.shareQrCode.setQrContent(data)
        that.shareVis = !that.shareVis
      })
    },
    // 获取团队信息
    getCompanyInfo() {
      var that = this
      if (!that.companyCode) {
        return;
      }
      that.$api.bz.getCompanyInfo({ code: that.companyCode }).then(res => {
        if (!res.success) {
          // that.$toast.warning('获取团队信息失败');
          console.log('获取团队信息失败', res)
          return
        }
        that.companyInfo = res.data
      })
    }
  }
}
</script>

<style scoped>
</style>
